import queryString from 'api/utils/queryStringBuilder';
import { getRequest as get, putRequest as put } from '../utils/HttpMethods';

interface S3Parameters {
  bucket: string;
  key: string;
  type?: string;
}

interface S3ListParameters {
  bucket: string;
  prefix: string;
}

export const generatePutSignedUrl = async ({
  bucket,
  key,
  type,
}: S3Parameters): Promise<any> => {
  const data = await put('QBilling', `/action/s3/put`, { bucket, key, type });
  const body = await data;
  return body;
};

export const generateGetSignedUrl = async ({ bucket, key }: S3Parameters) => {
  const data = await get(
    'QBilling',
    `/action/s3/get${queryString({ bucket, key })}`
  );
  const body = (await data) as string;
  return body;
};

export const listS3Objects = async ({
  bucket,
  prefix,
}: S3ListParameters): Promise<string[]> => {
  const data = await get(
    'QBilling',
    `/action/s3/list${queryString({ bucket, prefix })}`
  );
  const body = (await data) as string[];
  return body;
};
